import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import SelectOptionSearch from "../UI/SelectOptionSearch";
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";
import SelectProductStoreRoom from "../Factor/SelectProductStoreRoom";
import numericFunction from "../../utils/NumericFunction";
import {toast} from "react-toastify";
import {TransferBetweenStoresData} from "./TransferBetweenStoresData";
import {SetPrintDataContext} from "../../Pages";

const DateAndStore = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {
  const setPrint = useContext(SetPrintDataContext);

  const options = {year: 'numeric', month: '2-digit', day: '2-digit', calendar: 'persian'};
  const todayDate = new Date().toLocaleDateString('fa-IR', options);
  const navigateTo = useNavigate()


  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    // اگه سری اول خالی بود ینی بک اند چیزی نفرستاده و من باید تاریخ امروز رو بزارم جای  مقدار دیت
    if (sendData.date === "") {
      setSendData({date: todayDate})
    }
  }, [sendData.date])

  const [isActiveButton, setIsActiveButton] = useState(true)

  const [searchListArray, setSearchListArray] = useState([])

  const submitHandler = (wannaPrint = 0) => {
    // e.preventDefault();
    // console.log("sendData:::")
    const temp = {...sendData};
    if (temp.date === "") {
      toast.error("تاریخ نباید خالی باشد.")
      return
    }
    if (temp.tableData.length === 0) {
      toast.error("جزئیات حواله نباید خالی باشد.")
      return
    }
    temp.date = numericFunction.p2e(temp.date);
    console.log(temp);

    setIsActiveButton(false)
    _axios.post(prefixUrl() + "/storeRemittance/", {
      request: "remittanceConfirm",
      remittanceData: temp
    }).then(r => {
      setIsActiveButton(true)
      if (r.data.status) {
        toast.success(r.data.message);
        if (wannaPrint === 0) {
          setSendData(TransferBetweenStoresData.sendData);
        } else if (wannaPrint === 1) {
          r.data.invoiceData.entityName = ""
          r.data.invoiceData.type = "HAVALEANBAR";
          setPrint(r.data.invoiceData);
          navigateTo("/factorprint");

        }

        if (sendData.mode === "edit") {
          navigateTo(-1)
        }
      } else {
        toast.error(r.data.message)
      }
    }).catch(err => {
      setIsActiveButton(true)

    })

  }


  return (
    <>
      <h5 className="factor-title">حواله انبار</h5>

      <form>
        <div className="form-control">
          <div className="divgroup">
            <label htmlFor="date__havaleAnbar" className={"date__havaleAnbar"} >تاریخ</label>
            <div>
              <DatePicker
                onChange={(date) => {
                  if (date) {
                    setSendData({date: date.toLocaleString()})
                  } else {
                    setSendData({date: ""})
                  }
                }}

                calendar={persian}
                className="form-control"
                placeholder="تاریخ"
                locale={persian_fa}
                // value={sendData.date==="" ? "1" : sendData.date}
                value={sendData.date || todayDate}
                calendarPosition="bottom-right"
                hideOnScroll

              />
            </div>
          </div>
        </div>

        {/*<label htmlFor={"storeId"}>انبار مبدا:</label>*/}
        <SelectProductStoreRoom
          title={'انبار مبدا'}
          type={'sell'}
          selectedStore={(value, name) => {
            setComponentData({
              currentStoreId: value,
              currentStoreName: name
            })
          }}
        />


        {/*<label htmlFor={"storeId"}>انبار مقصد:</label>*/}
        <SelectProductStoreRoom
          title={'انبار مقصد'}

          type={'sell'}
          selectedStore={(value, name) => {
            setComponentData({
              destinationStoreId: value,
              destinationStoreName: name
            })
          }}
        />

        <input
          disabled={!isActiveButton}
          onClick={(e) => {
            e.preventDefault();
            submitHandler(0)
          }} type="submit" className={'btnCustom btnSubmit mt-5  py-5 w-100'}
          value={isActiveButton ? "ثبت حـوالــه انبار" : "در حال ارسال اطلاعات"}
        />
      </form>
      <button
        // className="print-btn btn-outline-primary"
        className={"btn__secondary_purple mt-2"}
        // onClick={submitAndPrint}
        onClick={(event) => {
          event.preventDefault();
          submitHandler(1);
        }}

        disabled={!isActiveButton}
      >
        <i className="fas fa-print mr-2"></i>ثبت و پرینت
      </button>


    </>
  );
};

export default DateAndStore;
